/**
 * product-new-ui-2026.js
 * Custom JS for the Product New UI 2026 template.
 * Loaded via: {{ 'product-new-ui-2026.js' | asset_url | script_tag }}
 */

(function () {
  /* ─────────────────────────────────────────────────────────────
     B: NOTE FIELD MODAL
  ───────────────────────────────────────────────────────────── */
  function initProductNoteModal() {
    document
      .querySelectorAll("[data-note-trigger]")
      .forEach(function (trigger) {
        var noteWrapper = trigger.closest("[data-product-note]");
        if (!noteWrapper) return;

        var modal = noteWrapper.parentNode.querySelector("[data-note-modal]");
        if (!modal) return;

        trigger.addEventListener("click", function (e) {
          e.preventDefault();
          openModal(modal);
        });

        modal.querySelectorAll("[data-note-close]").forEach(function (closer) {
          closer.addEventListener("click", function () {
            closeModal(modal);
          });
        });

        // Close on backdrop click (the backdrop itself has data-note-close,
        // but guard here too in case the structure changes)
        modal.addEventListener("click", function (e) {
          if (e.target === modal) closeModal(modal);
        });
      });

    // Single document-level keydown so we don't stack listeners per modal
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var openModal = document.querySelector("[data-note-modal]:not([hidden])");
      if (openModal) closeModal(openModal);
    });
  }

  function openModal(modal) {
    modal.removeAttribute("hidden");
    document.body.style.overflow = "hidden";
    var closeBtn = modal.querySelector(".product-note-modal__close");
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    modal.setAttribute("hidden", "");
    document.body.style.overflow = "";
  }

  /* ─────────────────────────────────────────────────────────────
     C: CALL FOR PRICE (zero-price variants)
     Button state on variant change; clicks handled globally in call-for-price.js
  ───────────────────────────────────────────────────────────── */
  function updateBuyButtonForCallForPrice(btn, variant) {
    var textEl = btn.querySelector("[data-add-to-cart-text]");
    if (!textEl) return;

    var callForPriceEnabled = btn.dataset.callForPriceEnabled === "on";
    var callForPriceLabel =
      btn.dataset.langCallForPrice || "Call for Price";
    var availableLabel =
      btn.dataset.langAvailableNormal || btn.dataset.langAvailable;
    var unavailableLabel = btn.dataset.langUnavailable;
    var soldOutLabel = btn.dataset.langSoldOut;

    var isZeroPrice =
      variant && typeof variant.price === "number" && variant.price === 0;

    if (callForPriceEnabled && isZeroPrice) {
      btn.type = "button";
      btn.removeAttribute("name");
      btn.removeAttribute("disabled");
      btn.removeAttribute("aria-disabled");
      textEl.textContent = callForPriceLabel;
      btn.setAttribute("data-call-for-price-active", "true");

      return;
    }

    btn.type = "submit";
    btn.name = "add";
    btn.removeAttribute("data-call-for-price-active");

    if (!variant) {
      btn.setAttribute("disabled", "disabled");
      btn.setAttribute("aria-disabled", "true");
      textEl.textContent = unavailableLabel;
    } else if (variant.available) {
      btn.removeAttribute("disabled");
      btn.removeAttribute("aria-disabled");
      textEl.textContent = availableLabel;
    } else {
      btn.setAttribute("disabled", "disabled");
      btn.setAttribute("aria-disabled", "true");
      textEl.textContent = soldOutLabel;
    }
  }

  function initCallForPriceButtons() {
    var productContainer = document.querySelector(
      '[data-is-full-product="true"]'
    );
    if (!productContainer) return;

    document.addEventListener("product:variant-change", function (e) {
      var variant = e.detail && e.detail.variant;
      var buttons = productContainer.querySelectorAll(
        "[data-call-for-price-config]"
      );

      buttons.forEach(function (btn) {
        updateBuyButtonForCallForPrice(btn, variant);
      });
    });
  }

  /* ─────────────────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────────────────── */
  function init() {
    initProductNoteModal();
    initCallForPriceButtons();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("DOMContentLoaded", function () {
    const locations = document.querySelectorAll("[data-pickup-location]");

    locations.forEach(function (location) {
      if (location.innerText.includes("Icily Cape Town")) {
        location.style.display = "none";
      }
    });
  });
})();
